import { useAppSelector } from '@/redux/store'
import { useRouter } from 'expo-router'
import { useEffect } from 'react'

// TODO: handle universal links
export default function AppPage() {
  const router = useRouter()
  const signedIn = useAppSelector(state => state.session.signedIn)

  useEffect(() => {
    if (router.canGoBack()) {
      router.back()
    } else {
      setTimeout(() => {
        router.replace(signedIn ? '/forms' : '/login')
      })
    }
  }, [router, signedIn])

  return null
}
